module.exports = __webpack_public_path__ + "img/item3.52fc621f.png";